import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useReservationDefaultIsShowRoomPriceInCalender } from "./hooks/use-is-show-room-price-in-calender";

export const QuestionReservationDefaultIsShowRoomPriceInCalender = () => {
	const { isEdited, hasError, isShowRoomPriceInCalender, onSetIsShowRoomPriceInCalender } =
		useReservationDefaultIsShowRoomPriceInCalender();

	const title = "宿泊カレンダーで料金を表示する";
	const guide =
		"ゲストに表示される宿泊カレンダーで部屋料金を表示します。<br />部屋料金を非表示にすると、宿泊可能な日では料金の代わりに丸のアイコンとチェックマークのアイコンが表示されます。<br />";

	const label = "宿泊カレンダーで料金を表示する";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<CheckboxField
					value={isShowRoomPriceInCalender.value}
					label={label}
					handleChange={onSetIsShowRoomPriceInCalender}
				/>
			}
		/>
	);
};

QuestionReservationDefaultIsShowRoomPriceInCalender.displayName = "QuestionReservationDefaultIsShowRoomPriceInCalender";
